import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetInboxStatus as GetInboxStatusQuery} from 'nutshell-graphql-types';

import GET_INBOX_STATUS from '../queries/get-inbox-status.graphql';

export const useGetInboxStatus = () => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetInboxStatusQuery, Record<any, any>>(GET_INBOX_STATUS, {});

    const {inboxStatus} = makeDataDangerous(data);

    return {
        inboxStatus,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
